// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n#wrapper[data-v-cb6e1156] {\n  display: flex;\n  flex-direction: row;\n  height: 100%;\n  min-height: 100%;\n}\n#chat-app[data-v-cb6e1156]{\n  height: 100%;\n}\n.cemixbot-content[data-v-cb6e1156] {\n  display: none;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
